export const USERS_LIST_REQUEST = "USERS_LIST_REQUEST";
export const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS";
export const USERS_LIST_FAIL = "USERS_LIST_FAIL";

export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";
export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
export const USER_PROFILE_FAIL = "USER_PROFILE_FAIL";

export const USER_PROFILE_EDIT_REQUEST = "USER_PROFILE_EDIT_REQUEST";
export const USER_PROFILE_EDIT_SUCCESS = "USER_PROFILE_EDIT_SUCCESS";
export const USER_PROFILE_EDIT_FAIL = "USER_PROFILE_EDIT_FAIL";

export const USER_QUESTION_REQUEST = "USER_QUESTION_REQUEST";
export const USER_QUESTION_SUCCESS = "USER_QUESTION_SUCCESS";
export const USER_QUESTION_FAIL = "USER_QUESTION_FAIL";

export const USER_ANSWER_REQUEST = "USER_ANSWER_REQUEST";
export const USER_ANSWER_SUCCESS = "USER_ANSWER_SUCCESS";
export const USER_ANSWER_FAIL = "USER_ANSWER_FAIL";